import { YoutubeService } from '@wix/wix-vod-api-site-based/dist/src/public/services/youtube/youtube';

export const service = new YoutubeService({
  withCredentials: true,
  xsrfHeaderName: null,
  xsrfCookieName: null,
});
